import EventsApp from './Functionality/EventsApp';
import DeleteModal from '../../../Modals/DeleteModal';
import React, { forwardRef } from 'react';
import BookingsMainHeader from "../subComponents/BookingsMainHeader";
import EventTableApp from "./Functionality/EventTableApp";
import CustomTable from "../../../../components/table/CustomTable";
import {permissionObj} from "../../../../Helpers/permission";
import CustomButtonLink from "../../../../components/buttons/CustomButtonLink";
import CancelReservationModal from '../Modal/CancelReservationModal';
import CopyEventLinkModal from "./SubComponents/CopyEventLinkModal";

/**
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 */
const Events = forwardRef((props, ref) => {

    const {
        selectedList,
        setSelectedList,
        moduleId,
        subView,
        handleSubViewChange,
        searchElement,
        setSearchElement,
        permission,
        DEV,
        option,
        setSearch,
        simpleSearch,
        setSimpleSearch,
        setBodyForExport,
    } = props;

    const {
        t,
        modified,
        setModified,
        isAllChecked,
        setIsAllChecked,
        showCancelModal,
        showDeleteModal,
        handleHideModals,
        handleCancelEventByList,
        handleShowModals,
        handleCreateEventOnTable,
        handleDeleteEvent,
        results, setResults
    } = EventsApp({
        ref,
        setSelectedList,
        selectedList,
        option,
        moduleId
    }, );

    const {
        tableId,
        searchId,
        thead,
        tbody,
        getActionsButtons,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        page,
        rowsPerPage,
        showCheckbox,
        linkModal,
        setLinkModal,
        itemSelected,
        setItemSelected
    } = EventTableApp({
        selectedList,
        setSelectedList,
        setBodyForExport,
        modified,
        setModified,
        searchElement,
        handleShowModals,
        setResults,
        results,
        option,
        setIsAllChecked
    });

    return (
        <>
            <BookingsMainHeader
                subView={subView}
                handleSubViewChange={handleSubViewChange}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                permission={permission}
                DEV={DEV}
                option={option}
                page={page}
                rowsPerPage={rowsPerPage}
                setSearchResults={setResults}
                searchResults={results}
                setSearch={setSearch}
                simpleSearch={simpleSearch}
                setSimpleSearch={setSimpleSearch}
                setBodyForExport={setBodyForExport}
            />

            <CustomTable
                tableId={tableId}
                searchId={searchId}
                checkbox={showCheckbox} // Enable checkboxes
                checkboxTitle={'de_/_select_all'} // Title for "Select All / Deselect All"
                isAllChecked={isAllChecked} // Whether all checkboxes are selected
                onChangeCheckbox={handleDeleteAll} // Handler for checkbox change
                thead={thead} // Table header
                tbody={tbody} // Table body data
                columnActions={true} // Enable column actions
                getActionsButtons={getActionsButtons} // Function to get action buttons
                handleCheckboxChange={handleCheckboxChange} // Checkbox handler for individual rows
                selectedList={selectedList} // List of selected rows
                childrenNotInformation={tbody?.data?.length === 0 ?
                    <>
                        <div className={"warning-text"}>
                            <p>{t("you_have_not_created_any_reservations_yet")}</p>
                        </div>
                        { (DEV || permission?.includes(permissionObj?.WEB_EVENT_CREATE)) &&
                        <CustomButtonLink
                            className={'d-block'}
                            splitName={false}
                            id={'btn_e_create_event'}
                            card={true}
                            onClick={() => {
                                handleCreateEventOnTable();
                            }}
                            name='add_new_reservation'
                        />
                        }
                    </>
                    : undefined
                }
            />
            {pagination()}

            {showDeleteModal && (
                <DeleteModal
                    show={showDeleteModal}
                    onHide={() => {
                        handleHideModals();
                    }}
                    onClickFn={() => {
                        handleDeleteEvent()
                    }}
                    data={selectedList}
                    title_modal={t('delete_events')}
                    description={'are_you_sure_you_want_to_delete'}
                    element_modal={t('events')}
                />
            )}

            {showCancelModal && (
                <CancelReservationModal
                    title='cancel_reservation'
                    show={showCancelModal}
                    onHide={handleHideModals}
                    onConfirm={(description) => handleCancelEventByList(description)}
                    t={t}
                />
            )}

            {linkModal &&
                <CopyEventLinkModal
                    show={linkModal}
                    setShow={setLinkModal}
                    itemSelected={itemSelected}
                    setItemSelected={setItemSelected}
                    setSelectedList={setSelectedList}
                />
            }
        </>
    );

});

export default Events;
